import moment from 'moment'

const constants = {
  state: {
    // todo: use process.env where required
    lateTime: moment('2 +0530', 'HH ZZ'),
    phoneNumber: {
      us: '+1-844-804-4822',
      in: '+91-9987-779-334'
    },
    invoiceStage: {
      review: 'Review and Submit'
    }
  }
}

export default constants
